module.exports = __webpack_public_path__ + "4ae8e318fcf75089ad1bb34a61805fd4.MP3";